import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import mainImage from "../../static/media/FacialStetic/main.webp";

const PRIMARY = "#06BBC7";
const BLACK = "#111827";
const YELLOW = "#F7C948";
const YELLOW_HOVER = "#efbd35";

const FacialAdvice = () => {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        pt: { xs: 5, md: 7 },
        pb: { xs: 5, md: 8 },
        background:
          "linear-gradient(180deg, rgba(6, 187, 199, 0.08) 0%, rgba(6, 187, 199, 0.04) 30%, #ffffff 78%, #ffffff 100%)",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "0.92fr 1fr" },
            alignItems: "center",
            justifyItems: "center",
            gap: { xs: 3.5, md: 5.5 },
          }}
        >
          <Box
            component={motion.div}
            initial={{ opacity: 0, x: -28, scale: 0.98 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.28 }}
            transition={{ duration: 0.75, ease: "easeOut" }}
            sx={{
              order: { xs: 1, md: 1 },
              position: "relative",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: { xs: "92%", sm: "78%", md: "88%", lg: "82%" },
                maxWidth: { xs: 420, sm: 520, md: 610 },
                borderRadius: { xs: "22px", md: "30px" },
                overflow: "hidden",
                border: "1px solid rgba(6, 187, 199, 0.16)",
                boxShadow: "0 18px 46px rgba(15, 23, 42, 0.1)",
                bgcolor: "transparent",
              }}
            >
              <Box
                component="img"
                src={mainImage}
                alt="Asesoría profesional en tratamientos faciales"
                loading="lazy"
                sx={{
                  width: "100%",
                  height: { xs: 260, sm: 340, md: 430, lg: 470 },
                  objectFit: "cover",
                  objectPosition: "center",
                  display: "block",
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              order: { xs: 2, md: 2 },
              textAlign: "center",
              maxWidth: { xs: 640, md: 620 },
              mx: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              component="h2"
              sx={{
                fontFamily: "'Playfair Display', serif",
                color: "#1d2530",
                fontSize: {
                  xs: "2.05rem",
                  sm: "2.7rem",
                  md: "3.45rem",
                },
                fontWeight: 500,
                lineHeight: 1.05,
                letterSpacing: "-0.055em",
                mb: { xs: 2.2, md: 2.8 },
              }}
            >
              Te asesoramos para elegir el tratamiento facial ideal
            </Typography>

            <Box
              component={motion.div}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 0.65, ease: "easeOut" }}
              sx={{
                width: "100%",
              }}
            >
              <Typography
                sx={{
                  color: "#374151",
                  fontSize: { xs: "1rem", md: "1.08rem", lg: "1.14rem" },
                  lineHeight: 1.85,
                  fontWeight: 400,
                  maxWidth: 590,
                  mx: "auto",
                  mb: { xs: 2.2, md: 2.6 },
                  textAlign: "center",
                }}
              >
                En Lily&apos;s Sunflower realizamos tratamientos faciales
                enfocados en limpiar, hidratar, renovar y mejorar la apariencia
                de tu piel con protocolos personalizados.
              </Typography>

              <Typography
                sx={{
                  color: "#4b5563",
                  fontSize: { xs: "1rem", md: "1.08rem", lg: "1.14rem" },
                  lineHeight: 1.85,
                  fontWeight: 400,
                  maxWidth: 560,
                  mx: "auto",
                  mb: { xs: 3, md: 3.4 },
                  textAlign: "center",
                }}
              >
                Nuestro equipo te acompaña desde la evaluación inicial para
                recomendarte el cuidado más adecuado según tu tipo de piel,
                necesidades y objetivos.
              </Typography>
            </Box>

            <Box
              component={motion.div}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, delay: 0.08, ease: "easeOut" }}
            >
              <Button
                component="a"
                href="/agendar-cita"
                variant="contained"
                sx={{
                  bgcolor: YELLOW,
                  color: BLACK,
                  px: { xs: 3.5, md: 4.4 },
                  py: 1.25,
                  borderRadius: "999px",
                  textTransform: "none",
                  fontWeight: 800,
                  fontSize: { xs: "0.96rem", md: "1rem" },
                  boxShadow: "none",
                  "&:hover": {
                    bgcolor: YELLOW_HOVER,
                    color: BLACK,
                    boxShadow: "none",
                  },
                }}
              >
                Recibir asesoría
              </Button>
            </Box>
          </Box>

          <Box
            sx={{
              order: { xs: 3, md: 3 },
              gridColumn: { xs: "1", md: "1 / -1" },
              width: { xs: 190, sm: 260, md: 340 },
              mx: "auto",
              mt: { xs: 1.5, md: 2 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1.5,
              color: PRIMARY,
            }}
          >
            <Box sx={{ flex: 1, height: 2, bgcolor: PRIMARY, borderRadius: 10 }} />
            <Box sx={{ width: 7, height: 7, bgcolor: PRIMARY, borderRadius: "50%" }} />
            <Typography
              component="span"
              sx={{
                fontSize: { xs: 28, sm: 34 },
                lineHeight: 1,
                color: PRIMARY,
                fontWeight: 300,
              }}
            >
              ✽
            </Typography>
            <Box sx={{ width: 7, height: 7, bgcolor: PRIMARY, borderRadius: "50%" }} />
            <Box sx={{ flex: 1, height: 2, bgcolor: PRIMARY, borderRadius: 10 }} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default FacialAdvice;